(() => {
  'use strict';

  const mobile = window.matchMedia('(max-width: 560px)');

  function setExpanded(menu, expanded) {
    const toggle = menu.querySelector('[data-footer-menu-toggle]');
    const links = menu.querySelector('[data-footer-menu-links]');
    if (!toggle || !links) return;
    toggle.setAttribute('aria-expanded', String(expanded));
    links.hidden = !expanded;
  }

  function syncViewport(menu) {
    const toggle = menu.querySelector('[data-footer-menu-toggle]');
    if (!toggle) return;
    // Desktop headings remain static; all links are available without JavaScript.
    toggle.disabled = !mobile.matches;
    setExpanded(menu, !mobile.matches);
  }

  function initialize(scope) {
    scope.querySelectorAll('[data-footer-menu]').forEach((menu) => {
      if (menu.dataset.mobileFooterReady) return;
      const toggle = menu.querySelector('[data-footer-menu-toggle]');
      if (!toggle || !menu.querySelector('[data-footer-menu-links]')) return;
      menu.dataset.mobileFooterReady = 'true';
      toggle.addEventListener('click', () => {
        if (!mobile.matches) return;
        setExpanded(menu, toggle.getAttribute('aria-expanded') !== 'true');
      });
      syncViewport(menu);
    });
  }

  initialize(document);
  mobile.addEventListener('change', () => {
    document.querySelectorAll('[data-footer-menu]').forEach(syncViewport);
  });
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
